export default __webpack_public_path__ + "static/media/adaptive-bike.1d69d1d8.svg";